let audioContext = null;

function resolveAudioContext() {
	if (typeof window === 'undefined') return null;
	const Ctor = window.AudioContext;
	if (!Ctor) return null;
	audioContext = audioContext || new Ctor();
	return audioContext;
}

export function playSound(name) {
	const context = resolveAudioContext();
	if (!context) return;
	if (context.state === 'suspended') context.resume();

	const now = context.currentTime;
	const master = context.createGain();
	master.gain.value = 0.09;
	master.connect(context.destination);

	const tone = (frequency, offset, duration, type, peak) => {
		const osc = context.createOscillator();
		const gain = context.createGain();
		osc.type = type;
		osc.frequency.setValueAtTime(frequency, now + offset);
		gain.gain.setValueAtTime(0.0001, now + offset);
		gain.gain.exponentialRampToValueAtTime(peak, now + offset + 0.012);
		gain.gain.exponentialRampToValueAtTime(0.0001, now + offset + duration);
		osc.connect(gain);
		gain.connect(master);
		osc.start(now + offset);
		osc.stop(now + offset + duration + 0.02);
		return osc;
	};

	switch (name) {
		case 'click':
			tone(680, 0, 0.07, 'triangle', 0.6);
			break;
		case 'success':
			tone(523.25, 0, 0.13, 'triangle', 0.8);
			tone(783.99, 0.09, 0.2, 'triangle', 0.8);
			break;
		case 'claim':
			tone(659.25, 0, 0.1, 'triangle', 0.7);
			tone(987.77, 0.08, 0.1, 'triangle', 0.7);
			tone(1318.51, 0.16, 0.24, 'triangle', 0.8);
			break;
		case 'deploy': {
			const sweep = tone(300, 0, 0.42, 'sawtooth', 0.5);
			sweep.frequency.exponentialRampToValueAtTime(900, now + 0.34);
			tone(1046.5, 0.3, 0.3, 'triangle', 0.7);
			break;
		}
		case 'error':
			tone(180, 0, 0.16, 'square', 0.4);
			tone(150, 0.1, 0.2, 'square', 0.4);
			break;
		default:
			break;
	}
}

const CONFETTI_LIGHT = ['#d6fe52', '#161613', '#e5484d', '#57c94a', '#59a5ff', '#ff8ec2'];
const CONFETTI_DARK = ['#f4c518', '#161613', '#e5484d', '#57c94a', '#59a5ff', '#ff8ec2'];

export function burstConfetti(x, y, dark) {
	if (typeof document === 'undefined') return;
	const palette = dark ? CONFETTI_DARK : CONFETTI_LIGHT;

	for (let i = 0; i < 28; i++) {
		const piece = document.createElement('div');
		const size = 5 + Math.random() * 7;
		piece.style.cssText = `position:fixed;left:${x}px;top:${y}px;width:${size}px;height:${size * 0.62}px;background:${palette[i % palette.length]};border:1px solid rgba(38,37,31,.45);border-radius:2px;z-index:9999;pointer-events:none;`;
		document.body.appendChild(piece);

		const angle = Math.random() * Math.PI * 2;
		const distance = 50 + Math.random() * 130;
		const dx = Math.cos(angle) * distance;
		const dy = Math.sin(angle) * distance - 30;

		piece.animate(
			[
				{ transform: 'translate(0,0) rotate(0)', opacity: 1 },
				{
					transform: `translate(${dx.toFixed(0)}px,${(dy + 170).toFixed(0)}px) rotate(${(Math.random() * 720 - 360).toFixed(0)}deg)`,
					opacity: 0,
				},
			],
			{ duration: 850 + Math.random() * 550, easing: 'cubic-bezier(.15,.75,.35,1)', fill: 'forwards' },
		);

		setTimeout(() => piece.remove(), 1450);
	}
}
